export const GET_ADVERTS = 'sales/GET_ADVERTS';
export const GET_ADVERTS_SUCCESS = 'sales/GET_ADVERTS_SUCCESS';
export const GET_ADVERTS_FAIL = 'sales/GET_ADVERTS_FAIL';

export const ADD_COMMENT = 'sales/ADD_COMMENT';
export const ADD_COMMENT_SUCCESS = 'sales/ADD_COMMENT_SUCCESS';
export const ADD_COMMENT_FAIL = 'sales/ADD_COMMENT_FAIL';

export const START_BULL = 'sales/START_BULL';
